export const requestMixin = {
    data() {
        return {
            rejectId: null,     //  退件單號 guid
            invalidId: null,    //  作廢單號 guid
        }
    },
    methods: {
        // 呈現退件按鈕的判斷
        isCaseReject(row) {
            if (
                row.purchase === this.$userInfo.account &&
                (row.status === "需求單位已確認" || row.status === "採購單位處理中") &&
                !row.notifyToSupplier
            ) {
                return true;
            }

            return false;
        },
        // 設定退件 id ,提供給輔助視窗確認後使用
        setReject(id) {
            const vm = this;

            vm.rejectId = id;
        },

        // 呈現作廢按鈕的判斷
        isCaseInvalid(row) {
            if (
                row.status === "需求單位開立中" &&
                row.applicant === this.$userInfo.account
            ) {
                return true;
            } else if (
                row.purchase === this.$userInfo.account &&
                (row.status === "需求單位已確認" ||
                row.status === "採購單位處理中" ||
                row.status === "廠商報價中")
            ) {
                return true;
            }

            return false;
        },
        // 設定作廢 id ,提供給輔助視窗確認後使用
        setInvalidId(id) {
            const vm = this;

            vm.invalidId = id;
        },
    },
};